import { Component, OnInit } from '@angular/core';

import { KoppelcodeInvoerenDirective } from '../koppelcode-invoeren/koppelcode-invoeren.directive';
import { RedirectUrls } from '../pairing-code/pairing-code.model';

@Component({
    selector: 'retail-koppelcode-invoeren',
    templateUrl: './retail-koppelcode-invoeren.component.html',
    standalone: false
})
export class RetailKoppelcodeInvoerenComponent extends KoppelcodeInvoerenDirective implements OnInit {
    public ngOnInit(): void {
        super.ngOnInit();
        this.samenRekeningOpenenUrl = this.contentService.get(this.content.SAMEN_REKENING_OPENEN_RETAIL_URL);
    }

    protected override getRedirectUrl(redirectUrls: RedirectUrls): string {
        const { redirectUrlRetail, redirectUrl } = redirectUrls;
        return this.decodeUrl(redirectUrlRetail || redirectUrl);
    }
}
